import { render, staticRenderFns } from "./SocialItem.vue?vue&type=template&id=d3c80278"
import script from "./SocialItem.vue?vue&type=script&lang=js"
export * from "./SocialItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports